import { useEffect } from "react";
import ReactGA from "react-ga4";

import GrpcStyles from "./grpc-styles-css.module.css";
import {
    Box, Container, Heading, Text, Button, TableContainer,
    Table,
    Thead,
    Tr,
    Th,
    Tbody,
    Td,
    Flex
} from "@chakra-ui/react";
import GrpcDediStyles from "./grpc-dedi-css.module.css";

import ClientRollingSection from "../LandingPage/LandingPageComponents/ClientRollingSection";
import GrpcDedicatedMap from "./GrpcDedicatedMap";
import CombinedHeading from "../common/CombinedHeading";
import { linksConfig } from "../../utils/CommonLinks";

const Grpcdedicated = () => {
    useEffect(() => {
        document.title = "Shyft | Yellowstone Geyser Plugin Solana Nodes";
        ReactGA.send({
            hitType: "pageview",
            page: "/solana-dedicated-grpc-nodes",
        });
    }, []);
    return (
        <>
            <Box as="section" className={`${GrpcStyles.hero}`}>
                <Container maxW={"7xl"}>
                    <Heading as="h1" color={"white"}>
                        Solana{" "}{" "}
                        <Text as="span" color={"brand.red"}>
                            Dedicated gRPC
                        </Text>{" "}
                        Nodes{" "}
                    </Heading>
                    <Text as="p">
                        We understand that every millisecond counts for Solana devs, thats why our dedicated nodes are accelerated by Jito 
                        Shredstreams to deliver the lowest latency possible. No downtime thanks to our backup pools.
                    </Text>
                    <Box as="div" className={`${GrpcStyles.button_group}`}>
                        <Button
                            as={"a"}
                            href={linksConfig.DISCORD_LINK}
                            target="_blank"
                            pt={"12px"}
                            pb={"10px"}
                            display={"block"}
                            size={"sm"}
                            // width={"28"}
                            height={"10"}
                            // maxW={"180px"}
                            w={{ base: "full", lg: "160px" }}
                            border={"1px solid"}
                            borderColor={"brand.red"}
                            bgColor={"brand.red"}
                            color={"brand.white"}
                            borderRadius={"full"}
                            textColor={"#fff"}
                            fontFamily={"heading"}
                            fontWeight={"500"}
                            _hover={{
                                bgColor: "brand.white",
                                color: "brand.red",
                                borderColor: "brand.white",
                                textDecoration: "none",
                            }}
                            mt={{ base: 2, md: 1, lg: 0 }}
                            textAlign={"center"}
                        >
                            Connect with Us
                        </Button>
                        <Button
                            as={"a"}
                            href="#solana-grpc-dedicated-plans"
                            pt={"12px"}
                            pb={"10px"}
                            display={"block"}
                            size={"sm"}
                            // width={"28"}
                            height={"10"}
                            // maxW={"300px"}
                            w={{ base: "full", lg: "160px" }}
                            border={"1px solid"}
                            borderColor={"brand.red"}
                            bgColor={"brand.black"}
                            color={"brand.white"}
                            borderRadius={"full"}
                            textColor={"#fff"}
                            fontFamily={"heading"}
                            fontWeight={"500"}
                            _hover={{
                                bgColor: "brand.red",
                                color: "brand.white",
                                textDecoration: "none",
                            }}
                            mt={{ base: 2, md: 1, lg: 0 }}
                            textAlign={"center"}
                        >
                            View Plans
                        </Button>
                        <Button
                            as={"a"}
                            href="https://docs.shyft.to/solana-grpc-shredstream/grpc-docs"
                            target="_blank"
                            pt={"12px"}
                            pb={"10px"}
                            display={"block"}
                            size={"sm"}
                            // width={"28"}
                            height={"10"}
                            // maxW={"300px"}
                            w={{ base: "full", lg: "160px" }}
                            border={"1px solid"}
                            borderColor={"brand.red"}
                            bgColor={"brand.black"}
                            color={"brand.white"}
                            borderRadius={"full"}
                            textColor={"#fff"}
                            fontFamily={"heading"}
                            fontWeight={"500"}
                            _hover={{
                                bgColor: "brand.red",
                                color: "brand.white",
                                textDecoration: "none",
                            }}
                            mt={{ base: 2, md: 1, lg: 0 }}
                            textAlign={"center"}
                        >
                            gRPC Docs
                        </Button>
                        
                    </Box>
                </Container>
            </Box>

            <Box as="section">
                <GrpcDedicatedMap />
            </Box>

            {/* <!-- Features Section --> */}
            <Box as="section" className={GrpcDediStyles.features}>
                <Container maxW={"7xl"}>
                    {/* <Heading as="h2" className={GrpcDediStyles.section_title} textColor={"brand.white"}>Fastest Solana gRPC Nodes</Heading>
                    <Text as="p" className={GrpcDediStyles.section_description}>Get the most efficient token swaps with our optimized infrastructure and region-specific endpoints.</Text> */}
                    <CombinedHeading 
                        topHeading="Low-Latency Streaming"
                        mainHeading="Fastest gRPC Nodes on Solana"
                        subHeading="Nodes perfectly suited for scalable streaming solutions, accelerated by Jito Shreds."
                        isCenter={true}
                    />

                    <Box as="div" className={GrpcDediStyles.features_grid}>
                        <Box as="div" className={GrpcDediStyles.feature_card}>
                            <Box as="div" className={GrpcDediStyles.feature_icon}>🌐</Box>
                            <Heading as="h3" textColor={"brand.white"}>Widespread availability</Heading>
                            <Text as="p">
                                Our dedicated nodes are available in multiple locations across Europe and the United States.
                            </Text>
                        </Box>
                        <Box as="div" className={GrpcDediStyles.feature_card}>
                            <Box as="div" className={GrpcDediStyles.feature_icon}>⚡</Box>
                            <Heading as="h3" textColor={"brand.white"}>Accelerated by Jito Shreds</Heading>
                            <Text as="p">Experience lightning-fast streaming with an 80–200ms advantage over shared gRPC services, accelerated by Jito Shreds.</Text>
                        </Box>
                        <Box as="div" className={GrpcDediStyles.feature_card}>
                            <Box as="div" className={GrpcDediStyles.feature_icon}>🛡️</Box>
                            <Heading as="h3" textColor={"brand.white"}>Fault-tolerant Infrastructure</Heading>
                            <Text as="p">A robust pool of backup nodes guarantees uninterrupted service, if your node goes down.</Text>
                        </Box>
                    </Box>
                </Container>
            </Box>
            <Box>
                <ClientRollingSection />
            </Box>
            <Box pb={8}>
                {/* <PricingStatic /> */}
                <Container maxW={"7xl"} id="solana-grpc-dedicated-plans">
                    <Box mh={"50px"} pt={{ base: 8, md: 8, lg: 16}} pb={{ base: 8, md: 8, lg: 8 }}>
                        <CombinedHeading 
                            topHeading="Tailored Plans, Perfect Fit"
                            mainHeading="Transparent Pricing"
                            subHeading="Customise your node based on your needs."
                            isCenter={true}
                        />
                    </Box>
                    <Box pb={{ base: 8, md: 8, lg: 8 }}>
                        <TableContainer borderBottom={"2px solid grey"}>
                            <Table variant='simple' className={GrpcDediStyles.dedi_plan_table}>
                                <Thead fontFamily={"heading"}>
                                    <Tr borderTopRightRadius={"14px"}>
                                        <Th textTransform={"capitalize"} fontSize={"md"} fontWeight={"400"} letterSpacing={"0px"} borderTopLeftRadius={"14px"}>CPU</Th>
                                        <Th textTransform={"capitalize"} fontSize={"md"} fontWeight={"400"} letterSpacing={"0px"} textAlign={"center"}>Memory</Th>
                                        <Th isNumeric textTransform={"capitalize"} fontSize={"md"} fontWeight={"400"} letterSpacing={"0px"} borderTopRightRadius={"14px"} pe={"55px"}>Price</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    <Tr>
                                        <Td>AMD 9254</Td>
                                        <Td>384 GB</Td>
                                        <Td>$1800/month</Td>
                                    </Tr>
                                    <Tr>
                                        <Td>AMD 7543</Td>
                                        <Td>1 TB</Td>
                                        <Td>$2000/month</Td>
                                    </Tr>
                                    <Tr>
                                        <Td>AMD 9354</Td>
                                        <Td>512 GB</Td>
                                        <Td>$2200/month</Td>
                                    </Tr>
                                    <Tr>
                                        <Td>AMD 9354</Td>
                                        <Td>768 GB</Td>
                                        <Td>$2500/month</Td>
                                    </Tr>
                                    <Tr>
                                        <Td>AMD 9254</Td>
                                        <Td>1 TB</Td>
                                        <Td>$2500/month</Td>
                                    </Tr>
                                    <Tr>
                                        <Td>AMD 9354</Td>
                                        <Td>1 TB</Td>
                                        <Td>$2800/month</Td>
                                    </Tr>

                                </Tbody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Box pb={{ base: 8, md: 8, lg: 8 }}>
                        <Flex flexWrap={"wrap"} justifyContent={"center"} alignItems={"center"} direction={{ base: "column", lg: "row" }}>
                            <Box flex={6} pe={{ base: 0, md: 8 }}>
                                <Text as="p" color={"brand.white"} pt={2}>
                                    Indexes can be enabled only on 1TB nodes. Transactions and gRPC plugin can be enabled on all nodes. 
                                    We suggest running separate nodes for RPC and gRPC usage for optimal performance. 
                                    <Text as={"span"} fontSize={{ base: "14px", lg: "md" }} fontWeight={"400"} color={"brand.yellow"} pt={{ base: "4px", md: "14px" }}> 
                                        Please reach out to us on <Text as={"span"} color={"brand.yellow"} _hover={{ color: "brand.red" }}>dashboard support</Text> or <Text as={"a"} href={linksConfig.DISCORD_LINK} target="_blank" color={"brand.yellow"} _hover={{ color: "brand.red" }}>discord</Text> to check for availability.</Text>
                                </Text>
                            </Box>
                            <Box flex={1}>
                                <Button
                                    as={"a"}
                                    href={linksConfig.DISCORD_LINK}
                                    target="_blank"
                                    pt={"12px"}
                                    pb={"10px"}
                                    display={"block"}
                                    size={"md"}
                                    // width={"28"}
                                    height={"12"}
                                    // maxW={"180px"}
                                    w={{ base: "full", lg: "180px" }}
                                    border={"1px solid"}
                                    borderColor={"brand.red"}
                                    bgColor={"brand.red"}
                                    color={"brand.white"}
                                    borderRadius={"full"}
                                    textColor={"#fff"}
                                    fontFamily={"heading"}
                                    fontWeight={"500"}
                                    _hover={{
                                        bgColor: "brand.white",
                                        color: "brand.red",
                                        borderColor: "brand.white",
                                        textDecoration: "none",
                                    }}
                                    mt={{ base: 2, md: 1, lg: 0 }}
                                    textAlign={"center"}
                                >
                                    Connect with Us
                                </Button>

                            </Box>
                        </Flex>
                        
                    </Box>
                </Container>
            </Box>


        </>
    );
};

export default Grpcdedicated;
